import { useEffect, useRef, useCallback, useState } from "react";
import "@/App.css";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import TechnologyOverview from "@/components/TechnologyOverview";
import TreatmentHeads from "@/components/TreatmentHeads";
import ClinicalResults from "@/components/ClinicalResults";
import BeforeAfterGallery from "@/components/BeforeAfterGallery";
import FeaturesBreakdown from "@/components/FeaturesBreakdown";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import RequestDemoModal from "@/components/RequestDemoModal";

function App() {
  const observerRef = useRef(null);
  const [demoOpen, setDemoOpen] = useState(false);

  const openDemo = () => setDemoOpen(true);
  const closeDemo = () => setDemoOpen(false);

  const setupObserver = useCallback(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    document.querySelectorAll(".reveal").forEach((el) => {
      observerRef.current.observe(el);
    });
  }, []);

  useEffect(() => {
    const timer = setTimeout(setupObserver, 100);
    return () => {
      clearTimeout(timer);
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [setupObserver]);

  return (
    <div className="grain-overlay" data-testid="cami-x-app">
      <Navigation onRequestDemo={openDemo} />
      <HeroSection onRequestDemo={openDemo} />
      <div className="section-separator" />
      <TechnologyOverview />
      <div className="section-separator" />
      <TreatmentHeads />
      <div className="section-separator" />
      <ClinicalResults />
      <div className="section-separator" />
      <BeforeAfterGallery />
      <div className="section-separator" />
      <FeaturesBreakdown />
      <div className="section-separator" />
      <CTASection onRequestDemo={openDemo} />
      <Footer />
      <RequestDemoModal open={demoOpen} onClose={closeDemo} />
    </div>
  );
}

export default App;
